import { render, staticRenderFns } from "./Limitations.vue?vue&type=template&id=6bae1c4e&scoped=true"
import script from "./Limitations.vue?vue&type=script&lang=js"
export * from "./Limitations.vue?vue&type=script&lang=js"
import style0 from "./Limitations.vue?vue&type=style&index=0&id=6bae1c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae1c4e",
  null
  
)

export default component.exports